import classnames from 'classnames';
import React, { PropTypes } from 'react';
import { values } from 'lodash';
import { StyleSheet, css } from 'aphrodite';
import Providers from 'es6/core/oauth-providers';

function OauthButton({ isLoading, provider, onClick, children }) {
  const providers = {};

  providers.google = (
    <g id="Google" stroke="none" strokeWidth="1" fill="none" fill-rule="evenodd" transform="translate(-3.000000, -4.000000)">
      <path d="M14,11.8666667 C15.8777778,11.8666667 17.1444444,12.6777778 17.8666667,13.3555556 L20.6888889,10.6 C18.9555556,8.98888889 16.7,8 14,8 C10.0888889,8 6.7111111,10.2444444 5.06666667,13.5111111 L8.3,16.0222222 C9.1111111,13.6111111 11.3555556,11.8666667 14,11.8666667 L14,11.8666667 L14,11.8666667 L14,11.8666667 L14,11.8666667 Z" id="Shape" fill="#EA4335"></path>
      <path d="M23.6,18.2222222 C23.6,17.4 23.5333333,16.8 23.3888889,16.1777778 L14,16.1777778 L14,19.8888889 L19.5111111,19.8888889 C19.4,20.8111111 18.8,22.2 17.4666667,23.1333333 L20.6222222,25.5777778 C22.5111111,23.8333333 23.6,21.2666667 23.6,18.2222222 L23.6,18.2222222 L23.6,18.2222222 L23.6,18.2222222 L23.6,18.2222222 Z" id="Shape" fill="#4285F4"></path>
      <path d="M8.3111111,19.9777778 C8.1,19.3555556 7.9777778,18.6888889 7.9777778,18 C7.9777778,17.3111111 8.1,16.6444444 8.3,16.0222222 L5.06666667,13.5111111 C4.38888889,14.8666667 4,16.3888889 4,18 C4,19.6111111 4.38888889,21.1333333 5.06666667,22.4888889 L8.3111111,19.9777778 L8.3111111,19.9777778 L8.3111111,19.9777778 L8.3111111,19.9777778 L8.3111111,19.9777778 Z" id="Shape" fill="#FBBC05"></path>
      <path d="M14,28 C16.7,28 18.9666667,27.1111111 20.6222222,25.5777778 L17.4666667,23.1333333 C16.6222222,23.7222222 15.4888889,24.1333333 14,24.1333333 C11.3555556,24.1333333 9.1111111,22.3888889 8.3111111,19.9777778 L5.07777778,22.4888889 C6.7222222,25.7555556 10.0888889,28 14,28 L14,28 L14,28 L14,28 L14,28 Z" id="Shape" fill="#34A853"></path>
      <polygon id="Shape" points="4 8 24 8 24 28 4 28 4 8 4 8"></polygon>
      <rect id="Rectangle-34" x="0" y="0" width="33" height="33" rx="2"></rect>
    </g>
  );

  providers.facebook = (
    <g id="Facebook" stroke="none" strokeWidth="1" fill="none" fill-rule="evenodd" transform="translate(-3.000000, -4.000000)">
      <path d="M18.0543284,31.9339701 L18.0543284,19.5930746 L22.1967761,19.5930746 L22.8168358,14.7835224 L18.0543284,14.7835224 L18.0543284,11.7128358 C18.0543284,10.3203582 18.4409552,9.37146269 20.4378507,9.37146269 L22.9847164,9.37026866 L22.9847164,5.06865672 C22.544,5.01014925 21.0323582,4.87916418 19.2734328,4.87916418 C15.6015522,4.87916418 13.0876418,7.12047761 13.0876418,11.2366567 L13.0876418,14.7835224 L8.9346866,14.7835224 L8.9346866,19.5930746 L13.0876418,19.5930746 L13.0876418,31.9339701 L18.0543284,31.9339701" id="Fill-2" fill="#3B5998"></path>
      <rect id="Rectangle-34" x="0" y="0" width="33" height="33" rx="2"></rect>
    </g>
  );

  providers.dmm = (
    <g id="DMM">
      <path d="M11.55,0H0V28H14c7,0,15.12-3.18,15.12-14S19.44,0,11.55,0Zm.8,18.29V9.56c2.11,0,5.34.1,5.34,4.34S14.58,18.29,12.35,18.29Z" fill="#010101" />
    </g>
  );

  return (
    <button className={classnames(css(styles.oauthButton), isLoading && css(styles.oauthButtonLoading))} onClick={onClick}>
      <div className={css(styles.iconWrapper)}>
        <svg
          className={css(styles.icon)}
          width="87px" height="28px" viewBox="0 0 87 28" version="1.1"
          xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink"
        >
          {providers[provider]}
        </svg>
      </div>
      <div className={classnames(css(styles.buttonText))}>{children}</div>
    </button>
  );
}

OauthButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  provider: PropTypes.oneOf(values(Providers)).isRequired,
  children: React.PropTypes.node,
};

OauthButton.defaultProps = {
  isLoading: false,
};

const styles = StyleSheet.create({
  oauthButton: {
    display: 'block',
    margin: '20px 0px',
    width: '100%',
    backgroundColor: '#fff',
    border: '1px solid #E1E0D8',
    boxShadow: '2px 2px 0px 0px #E1E0D8',
    borderRadius: '2px',
    color: '#54616E',
    cursor: 'pointer',
    fontSize: '14px',
    lineHeight: '3.3',
    padding: '0 1.4em',
    overflow: 'hidden',
    textAlign: 'left',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  oauthButtonLoading: {
    boxShadow: 'none',
    cursor: 'default',
  },
  iconWrapper: {
    display: 'inline-block',
    width: '33px',
    height: '33px',
  },
  icon: {
    display: 'inline-block',
    marginRight: '0.6em',
    verticalAlign: 'middle',
  },
  buttonText: {
    display: 'inline-block',
    width: 'calc(100% - 73px)',
    textAlign: 'center',
  },
});

export default OauthButton;
